<template>
  <!-- منوی سمت راست -->
  <div class="
      d-none d-md-flex d-lg-flex d-xl-flex
      flex-row
      justify-content-between
      align-items-center
      p-0
      wow
      fadeIn
      position-absolute
    ">
    <!-- استفاده از ایندکس در کار مودال اختلال ایجاد می کند -->
    <!-- style="z-index: 1;" -->
    <!-- منوی اصلی : ثابت سمت راست -->
    <div class="bg-dark vh-100 border-right-1 shadow border-white menuRight"
      v-bind:style="checkShowMenu ? 'box-shadow: none !important;' : ''">
      <!-- لوگو و نام -->
      <div class="row d-flex flex-column">
        <div>
          <img class="img-fluid imgLogo mt-2 p-1" :src="getImageUrl + 'LogoSite.png'" alt="LogoSite" />
          <span class="text-light d-block">سامانه مالی پرش</span>
          <span class="text-light d-block h7 mt-1">{{ getCurrentDate }}</span>
        </div>
        <div>
          <img class="img-fluid imgLogo rounded-circle p-2 mt-3" v-bind:src="getUserImage" alt="user" />
          <span class="d-block white-text pb-1">
            {{ getUserName }}
          </span>
          <div class="
              w100
              d-flex
              align-item-center
              justify-content-around
              mt-1
              pt-1
            ">
            <!-- ویرایش حساب کاربری -->
            <a v-on:click="CallUserProfileEdit" data-toggle="modal" data-target="#ModalUserProfileEdit"
              title="ویرایش حساب کاربری"><i class="fas fa-user-edit fa-lg white-text"></i></a>
            <!-- مشاهده سوابق فعالیت -->
            <a v-on:click="CallShowActivityList()" title="مشاهده سوابق فعالیت">
              <i class="fas fa-calendar-check fa-lg white-text"></i>
            </a>
            <!-- خروج از میزکار کاربر -->
            <a v-on:click="LogOutUser()" title="خروج از سامانه"><i class="fas fa-power-off fa-lg white-text"></i></a>
          </div>
        </div>

        <!-- منوی اصلی -->
        <div class="mt-5">
          <a class="d-flex flex-column justify-content-center align-items-center MainMenu"
            v-on:click="checkShowMenu = !checkShowMenu" title="نمایش منوها">
            <img class="px-3 MainMenu" :src="getImageUrl + 'ic_apps.png'" alt="apps" />
            <span class="text-white mt-1 MainMenu">منوی اصلی</span>
          </a>
        </div>

        <!-- لیست اسناد -->
        <div class="mt-5">
          <a class="d-flex flex-column justify-content-center align-items-center"
            v-on:click="addNewTab('ListDocInfo', 'اسناد')" title="مشاهده اسناد">
            <i class="fas fa-th-list fa-2x text-white"></i>
            <span class="text-white mt-1">اسناد</span>
          </a>
        </div>

        <!-- سند جدید -->
        <div class="mt-5">
          <a class="d-flex flex-column justify-content-center align-items-center"
            v-on:click="addNewTab('AccDoc', 'سند جدید')" title="ایجاد سند جدید">
            <i class="fas fa-file-invoice fa-2x text-white"></i>
            <span class="text-white mt-1">سند جدید</span>
          </a>
        </div>
      </div>

      <!-- نگارش و امضاء -->
      <div class="row" style="position: fixed; bottom: 5px; right: 5px">
        <div class="col text-center p-0">
          <!-- تغییر سال مالی -->
          <a id="SelectYearFromCalender" v-on:click="changeActiveYear" class="
              selectYear
              d-flex justify-content-center align-items-center 
              ml-1 mb-2 
              pt-1 pb-1
              rounded-pill
              bg-danger
              shadow
              text-white
              h5
              waves-effect waves-light
            " data-toggle="modal" data-target="#ModalSelectYear" title="تغییر سال مالی">
            <span class="h6 p-0 m-0 ml-1" style="padding-top: 4px !important;">{{ getYearActive }}</span>
            <i class="far fa-calendar-check fa-xs"></i>
          </a>
          <span class="text-white d-block mb-2" style="font-weight: 100">نگارش : {{ getVersionApp }}</span>
          <a href="http://parsrayanehco.ir" target="_blank" class="text-decoration-none">
            <span class="text-white d-block" style="font-weight: 100">پارس رایانه شاپرک</span>
          </a>
        </div>
      </div>
    </div>
    <!-- پایان منوی اصلی : ثابت سمت راست -->

    <!-- مودال انتخاب سال جاری -->
    <select-year-active v-if="isShowSelectYearActive" v-bind:YearInput="getYearActive"
      v-on:SetYearFromModal="HideModalSelectYear"></select-year-active>
    <!-- پایان مودال انتخاب سال جاری -->

    <!-- مودال ویرایش حساب کاربری -->
    <user-profile-edit v-if="isShowUserProfileEdit" v-bind:UserData="userDataForEditProfile"
      v-on:EditUser="HideModalUserProfileEdit"></user-profile-edit>
    <!-- پایان مودال ویرایش حساب کاربری -->

    <!-- منوی کشویی بازشونده -->
    <transition name="fade">
      <!-- منوی متحرک : سمت راست -->
      <div v-show="checkShowMenu" class="vh-100 text-right pt-2 bg-dark shadow MainMenu menuRight-movable">
        <div id="accordionMenu" class="accordion p-0 mt-2 bg-dark border-0 text-white">
          <!-- بررسی لود اطلاعات منوها -->
          <div v-if="getTbObjectsForShow(getNSystemID).length > 1">
            <!-- ساخت منوی سمت راست -->
            <div 
              v-for="(row, index) in getTbObjectsForShow(getNSystemID)"
              class="card border-0 rounded-0 bg-dark mb-2" 
              :key="row.NObjectId"
            >
              <!-- ساخت منوی های اصلی -->
              <div class="card-header border-0 bg-dark menu-header MainMenu">
                <a class="w-100 d-flex align-items-center MainMenu" data-toggle="collapse"
                  :data-target="'#collapse' + index">
                  <i :class="row.WebIconName" class="fa-1x-half fa-fw ml-2"></i>
                  {{ row.SObjectName_Fa }}
                </a>
              </div>
              <div :id="'collapse' + index" class="accordion-collapse collapse bg-dark" :class="index == 0 ? 'show' : ''">
                <!-- ساخت زیر منوها -->
                <div class="card-bady d-flex flex-column pr-5 pt-2 MainMenu"
                  v-for="subMenu in getTbObjectsForShow(row.NObjectId)" :key="subMenu.NObjectId">
                  <!-- اگر کاربر دسترسی داشت -->
                  <a v-on:click="addNewTab(subMenu.WebFormName, subMenu.SObjectName_Fa)" class="my-1 hover-check MainMenu"
                    :class="subMenu.WebFormName != '' ? 'lime-text' : 'text-white-50'"
                    v-if="checkResourceAccessUser(subMenu.NObjectId) == true">
                    <i class="far fa-list-alt ml-2"
                      :class="subMenu.WebFormName != '' ? 'lime-text' : 'text-white-50'"></i>
                    {{ subMenu.SObjectName_Fa }}
                  </a>
                  <!-- اگر کاربر دسترسی نداشت -->
                  <span class="text-white-50 my-1" style="cursor: pointer;" title="شما به این فرم دسترسی ندارید !" v-else>
                    <i class="far fa-list-alt fa-rotate-45 ml-2"></i>
                    <del>{{ subMenu.SObjectName_Fa }}</del>
                  </span>
                </div>
              </div>
            </div>
            <!-- پایان ساخت منوی سمت راست -->
          </div>
          <!-- عدم لود اطلاعات -->
          <div v-else class="d-flex flex-column align-items-center justify-content-center" style="height: 95vh;">
            <i class='fas fa-cog fa-spin fa-2x text-warning' style="width: 20px"></i>
            <span class="mt-3 mb-2 h7">در حال دریافت اطلاعات از سرور</span>
            <span class="h6">لطفا صبر نمایید ...</span>
          </div>
        </div>
      </div>
      <!-- پایان منوی متحرک : سمت راست -->
    </transition>
    <!-- پایان منوی کشویی بازشونده -->

  </div>
</template>

<script>
import { newRoutes } from "../../../../main";
import { BusEvent } from "../../../../main.js";
import SelectYearActive from "./Components/SelectYearActive.vue"
import UserProfileEdit from "./Components/UserProfileEdit.vue"

export default {
  components: {
    "select-year-active": SelectYearActive,
    "user-profile-edit": UserProfileEdit,
  },
  data() {
    return {
      checkShowMenu: false,
      isShowSelectYearActive: false,
      // کنترل نمایش ویرایش اطلاعات پروفایل
      isShowUserProfileEdit: false,
      userDataForEditProfile: '',
      // لیست محلی دسترسی های کاربر لاگین کرده
      LocalResourceAccessLoginUser: [],
    };
  },
  computed: {
    // دریافت آدرس تصاویر
    getImageUrl() {
      return this.$store.getters.getImageUrl;
    },
    // دریافت تاریخ جاری
    getCurrentDate() {
      return this.$store.getters.getPersianDateValue.PersianDate;
    },
    // دریافت کد سیستم حسابداری
    getNSystemID() {
      return this.$store.getters.getNSystemID;
    },
    // دریافت نگارش نرم افزار
    getVersionApp() {
      return this.$store.getters.getVersionApp;
    },
    // دریافت تصویر کاربر
    getUserImage() {
      // var userImageUrl;
      // var SImageName = this.$store.getters.getUserData.SImageName;
      // userImageUrl =
      //   this.$store.getters.getImageUrl +
      //   "Users/" +
      //   (SImageName == null || SImageName === "" ? "User.png" : SImageName);
      // return userImageUrl;
      var userImage = this.$store.getters.getUserData.SImageUserBase64;
      if (userImage != null && userImage != "") {
        // دیتای سمت سرور دریافت شده است
        userImage = 'data:image/png;base64,' + userImage;
      } else {
        // چون هنوز دیتای سمت سرور دریافت نشده است
        // به صورت موقت از تصویر پیش فرض استفاده کن
        userImage = this.$store.getters.getImageUrl + "Users/User.png";
      }
      return userImage;

      // این روش مناسب فراخوانی تصویر سایر کاربران است
      //
      // دریافت توکن احراز هویت
      // var userdata = this.$store.getters.getUserData;
      // let NUserCode = userdata.NUserCode;
      // let token = userdata.token;
      // var strUserImage = await this.$store.dispatch("GetUserImage", {
      //   NUserCode: NUserCode,
      //   token: token,
      // });
      // if(strUserImage != null){
      //   return strUserImage;
      // } else {
      //   return this.$store.getters.getImageUrl + "Users/User.png";
      // }
    },
    // دریافت اسم کاربر
    getUserName() {
      return this.$store.getters.getUserData.SUserName;
    },
    // دریافت سال جاری
    getYearActive() {
      return this.$store.getters.getYearActive;
    },
    // فیلتر لیست محلی تمام سطوح دسترسی جهت ساخت منو
    getTbObjectsForShow() {
      return function (NObjectId) {
        // NObjectParentId
        let TbResourceList = this.$store.getters.getTbObjects;
        // if (NObjectId != this.getNSystemID) {
        //   // انتخاب سایر سطوح بر اساس سطر انتخاب شده
        //   let listTemp = TbResourceList.filter(function (item) {
        //     return item.NObjectParentId > NObjectId
        //   });
        //   return listTemp;
        // } else {
          // انتخاب سطح اصلی
          let listTemp = TbResourceList.filter(function (item) {
            return item.NObjectParentId == NObjectId
          });
          return listTemp;
        // }
      }
    },
    // کنترل سطح دسترسی کاربر
    checkResourceAccessUser() {
      return function (NObjectId) {
        let LocalResourceAccessLoginUser = this.$store.getters.getTbUserObjects;
        if (LocalResourceAccessLoginUser != null) {
          // آیا سطح دسترسی مورد نظر در لیست دسترسی های کاربر وجود دارد ؟
          let index = LocalResourceAccessLoginUser.findIndex(function (item) {
            return item.NObjectId == NObjectId
          });
          if (index != -1) {
            return true;
          } else {
            return false;
          }
        }
      }
    },

  },
  methods: {
    // رویداد بسته شدن منوی کشویی بازشونده
    CloseMainMenu() {
      this.checkShowMenu = false;
    },

    // فراخوانی سوابق فعالیت کاربر
    async CallShowActivityList() {
      // استخراج اطلاعات کاربر جاری
      var userData = await this.$store.getters.getUserData;
      // ثبت کد ملی کاربر جاری جهت فیلتر سوابق فعالیت
      this.$store.commit("setOnlyShowActivityListForUserID", userData.NUserCode);
      // فراخوانی تابع نمایش فرم سوابق فعالیت
      this.addNewTab('ActivityList', 'سوابق فعالیت کاربر (' + userData.SUserName + ')');
    },

    // رویداد ویرایش حساب کاربری
    async CallUserProfileEdit() {
      var userData = await this.$store.getters.getUserData;
      userData.TitelForm = 'ویرایش حساب کاربری';
      this.userDataForEditProfile = userData;
      this.isShowUserProfileEdit = true;
    },

    // رویداد بسته شدن مودال ویرایش حساب کاربری
    async HideModalUserProfileEdit(value) {
      var userData = await this.$store.getters.getUserData;
      userData.SUserName = value.SUserName;
      userData.NPerNationalId = value.NPerNationalId;
      userData.SMobileNo = value.SMobileNo;
      userData.SImageName = value.SImageName;
      if (value.ImageFormFile != null && value.ImageFormFile != "") {
        userData.SImageUserBase64 = value.ImageFormFile;
      } else {
        userData.SImageUserBase64 = value.SImageUserBase64;
      }
      this.$store.commit('setUserData', userData);
      this.isShowUserProfileEdit = false;
    },

    // رویداد تغییر سال جاری
    changeActiveYear() {
      this.isShowSelectYearActive = false;
      // صدور دستور بستن تمام تب های باز
      // این رویداد از TabHeader.vue فراخوانی می شود
      BusEvent.$emit("CloseAllTab", check => {
        if (check == true) {
          // تمام تب های باز بسته شده است - نمایش کادر تغییر سال
          this.isShowSelectYearActive = true;
        }
      }, "جهت تغییر سال جاری ، لازم است تمام تب‌های باز بسته شود .");
    },

    // رویداد بسته شدن مودال انتخاب سال
    HideModalSelectYear(value) {
      this.isShowSelectYearActive = false;
      if (value != 0 && value != this.getYearActive) {
        // سال مالی تغییر کرده است
        // فراخوانی رویداد بازیابی کل اطلاعات از کامپاننت AdminPanel
        BusEvent.$emit("LoadAllData", value);
      }
    },

    // رویداد ایجاد تب جدید
    async addNewTab(tabType, tabTitle) {
      if (tabType != "") {
        // کنترل سطح دسترسی کاربر بر اساس نام فرم
        let checkAccess = await this.$store.dispatch("checkAccessUser", tabType);
        // آیا کاربر به این نام فرم دسترسی دارد ؟
        if(checkAccess == true){
          var newNDocNum = 0;
          if (tabType === "AccDoc") {
            // دریافت کد برای تب جدید
            newNDocNum = await this.$store.dispatch("createNewNDouNum");
            if (newNDocNum == 1) {
              newNDocNum = await this.$store.getters.getLargestNDocNuNId;
            }
          }
          // ایجاد اطلاعات تب جدید
          var tabData = {
            tabID: 0,
            tabContent: tabType,
            tabContentTitle: tabTitle,
            NId: 0,
            NDocNu: newNDocNum,
            CheckChangeData: false,
            LocalData: false,
            TabAccDocData: {},
          };
          // ایجاد تب جدید
          this.$store.commit("addTabList", tabData);
          // ارسال شماره تب به رویداد تغییر تب فعال
          BusEvent.$emit("ChangeTabActive", tabData.tabID);
          // بستن منوی کشویی بازشونده
          this.CloseMainMenu();
        } else {
          // عدم تایید دسترسی کاربر
          swal({
            title: "عدم دسترسی به فرم",
            text: "دسترسی شما به این فرم تایید نمی شود ! \n" + "در صورت لزوم با مدیر سیستم تماس بگیرید .",
            icon: "error", // success, warning, error, info
            buttons: {
              ok: "بله متوجه شدم",
            },
          });
        }
      } else {
        // فرم مورد نظر پیاده سازی نشده است
        swal({
          title: "عدم پیاده سازی فرم",
          text: "فرمی که تقاضا کرده اید ، پیاده سازی نشده است !",
          icon: "info", // success, warning, error, info
          buttons: {
            ok: "بله متوجه شدم",
          },
        });
      }
    },

    // رویداد خروج کاربر
    async LogOutUser() {
      swal({
        title: "خروج از نرم افزار",
        text: "شما تقاضای خروج از نرم افزار را کرده اید .\n" + "آیا تایید می کنید ؟",
        icon: "info", // success, warning, error, info
        buttons: {
          cancel: "انصراف",
          ok: "بله خارج می‌شوم",
        },
      }).then(async (value) => {
        if (value) {
          // حذف کوکی نگهدارنده توکن
          // await this.$store.dispatch("removeAutuCookie");

          let token = await this.$store.getters.getUserData.token;
          await this.$store.dispatch("removeAutuCookie", { token });
          // تخلیه اطلاعات اسناد موقت هنگام خروج
          // await this.$store.commit("setTbTmpDocDataEmptyInLogOut");
          // خروج
          newRoutes.push("Login");
        }
      });
    },
  },
  created() {
    // رویداد بستن منوی کشویی بازشونده
    BusEvent.$on("CloseMainMenu", this.CloseMainMenu);
  },
  beforeDestroy() {
    // حذف رویداد بستن منوی کشویی بازشونده
    BusEvent.$off("CloseMainMenu", this.CloseMainMenu);
  }
};
</script>

<style scoped>
.selectYear:hover span {
  color: yellow;
}

.selectYear:hover i {
  color: yellow;
}

.fa-rotate-45 {
  transform: rotate(-45deg);
}

/* انیمیشن مربوط به منوی کشویی بازشونده */
/* مربوط به باز شدن منوی کشویی */
.fade-enter {
  opacity: 0;
}

.fade-enter-active {
  animation: slid-in 0.5s ease-in-out;
  transition: all ease 0.5s;
}

/* مربوط به بسته شدن منوی کشویی */
/* .fade-leave {
    
  } */
.fade-leave-active {
  animation: slid-out 0.5s ease-in-out;
  transition: all ease 0.5s;
  opacity: 0;
}

/* انیمیشن حرکتی ظاهر شدن منوی کشویی */
@keyframes slid-in {
  from {
    transform: translateX(150px);
  }

  to {
    transform: translateX(0px);
  }
}

/* انیمیشن حرکتی مخفی شدن منوی کشویی */
@keyframes slid-out {
  from {
    transform: translateX(0px);
  }

  to {
    transform: translateX(150px);
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/AdminPanel/Components/RightMenu/RightMenu.vue